// @flow
import React from 'react';

import TextField from 'material-ui/TextField';

import round from 'lodash/round';

const GND_LABEL = 'GND';
const GND_VALUE = 0;

const styles = {
  altitudeInput: {
    width: 150,
    marginRight: 16,
  },
};

const handleFocus = event => {
  const target = event.target;

  if (target.value === GND_LABEL) {
    target.value = GND_VALUE;
  }
};

const handleBlur = (setAltitudeRange, bound, prevValue) => event => {
  const target = event.target;
  const newRawValue = parseInt(event.target.value, 10);
  const newValue = round(isNaN(newRawValue) ? prevValue : newRawValue, -2);

  setAltitudeRange(bound, newValue);
  target.value = newValue == GND_VALUE ? GND_LABEL : newValue;
};

export default ({
  altitudeRange,
  transitionDuration,

  setAltitudeRange,
  setHUDStep,
}) => {
  const minValue =
    altitudeRange.min === GND_VALUE ? GND_LABEL : altitudeRange.min;
  const maxValue =
    altitudeRange.max === GND_VALUE ? GND_LABEL : altitudeRange.max;

  return (
    <div>
      <TextField
        floatingLabelText="Alsó határ (ft)"
        defaultValue={minValue}
        onFocus={handleFocus}
        onBlur={handleBlur(setAltitudeRange, 'min', altitudeRange.min)}
        style={styles.altitudeInput}
      />
      <TextField
        floatingLabelText="Felső határ (ft)"
        defaultValue={maxValue}
        onFocus={handleFocus}
        onBlur={handleBlur(setAltitudeRange, 'max', altitudeRange.max)}
        style={styles.altitudeInput}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/HUD/AltitudeStep.js